import { render, staticRenderFns } from "./Universes.vue?vue&type=template&id=12ba7dea&"
import script from "./Universes.vue?vue&type=script&lang=js&"
export * from "./Universes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports